import type { AssetGroup } from '@/entities/account';

export const TRADING_ACCOUNT_TYPES = [
  'spot',
  'leverage',
  'invest',
  'earn',
] as const;

export type TradingAccountType = (typeof TRADING_ACCOUNT_TYPES)[number];

export const TRADING_ASSETS_FILTER_ALL = 'all';

export type TradingAssetsFilter =
  | typeof TRADING_ASSETS_FILTER_ALL
  | TradingAccountType;

export type TradingAssetAccountEntry = {
  accountType: TradingAccountType;
  accNum: string;
  accName?: string;
  tradingAccKey?: number;
  amount: number;
  amountText: string;
  baseAmount: number;
  baseAmountText: string;
  equity?: number;
  margin?: number;
  freeMargin?: number;
  marginLevel?: number;
};

export type TradingAssetRow = {
  code: string;
  name: string;
  icon?: string;
  group?: AssetGroup;
  amount: number;
  amountText: string;
  baseAmount: number;
  baseAmountText: string;
  types: Array<TradingAccountType>;
  accounts: Array<TradingAssetAccountEntry>;
  isExpandable: boolean;
};

export type TradingAssetActionsVisibility = {
  trade: boolean;
  transfer: boolean;
};

export const TRADING_SORT_KEYS = {
  asset: 'asset',
  amount: 'amount',
  base: 'base',
} as const;

export type TradingSortKey =
  (typeof TRADING_SORT_KEYS)[keyof typeof TRADING_SORT_KEYS];
